import React from 'react';
import { Card, Table } from 'react-bootstrap';
import styles from './index.module.scss';

// functions
import dateToHumanReadable from '../../../functions/hreadableDate';
import timeDifference from '../../../functions/differenceDate';

const NoData = (props) => (
    <section className={styles.NoData}>
        No has empezado el tiempo el dia de hoy
    </section>
);

const ClockTable = (props) => (
    <Table striped bordered hover className={styles.Table}>
        <thead>
            <tr>
                <th>Tiempo</th>
                <th>Acción</th>
            </tr>
        </thead>
        <tbody>
            {props.clock.clockInTime && <tr>
                <td>{dateToHumanReadable(new Date(props.clock.clockInTime))}</td>
                <td>Entrada</td>
            </tr>}
            {props.clock.lunchInTime && <tr>
                <td>{dateToHumanReadable(new Date(props.clock.lunchInTime))}</td>
                <td>Lunch</td>
            </tr>}
            {props.clock.lunchOutTime && <tr>
                <td>{dateToHumanReadable(new Date(props.clock.lunchOutTime))}</td>
                <td>Lunch Finalizó</td>
            </tr>}
            {props.clock.clockOutTime && <tr>
                <td>{dateToHumanReadable(new Date(props.clock.clockOutTime))}</td>
                <td>Salida</td>
            </tr>}
            <tr className={styles.TotalRow}>
                <td>Total Trabajado</td>
                <td>{ timeDifference(props.clock.clockInTime, props.clock.clockOutTime, props.clock.lunchInTime, props.clock.lunchOutTime) }</td>
            </tr>
        </tbody>
    </Table>
);

const ClockList = (props) => {
    return (
        <Card className={styles.ClockList}>
            {props.clock ? <ClockTable clock={props.clock} /> : <NoData />}
        </Card>
    );
};

export default ClockList;